import React from 'react';
import styles from './SystemCombinations.module.scss';
import { ticketTypeEnum } from '../../../constants/enums';
import { useDispatch, useSelector } from 'react-redux';
import useComponentVisible from '../../../hooks/useComponentVisible';
import { changeBetSlipCombinations } from '../../../store/actions/betSlip';
import betSlipCalculator from '../../../utils/betSlipCalculator';
import { getTranslation } from '../../../utils/translation';

const SystemCombinations = () => {
    const dispatch = useDispatch();

    const commonValidations = useSelector(state => state.betSlip.validations.common);
    const betLines = useSelector(state => state.betSlip.betLines);
    const activeTab = useSelector(state => state.betSlip.activeTab);
    const selectedCombinations = useSelector(state => state.betSlip.selectedCombinations);
    const stakes = useSelector(state => state.betSlip.stakes);

    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    const systems = betSlipCalculator.generateSystems(betLines, stakes[ticketTypeEnum.SYSTEM]);

    const onCombinationsMenuClick = () => {
        if (commonValidations.length > 0) return;
        setIsComponentVisible(!isComponentVisible);
    };

    const onToggle = combinationId => {
        setIsComponentVisible(false);

        let newSelectedCombinations = [];

        if (selectedCombinations.includes(combinationId)) {
            newSelectedCombinations = selectedCombinations.filter(c => c !== combinationId);
        } else {
            newSelectedCombinations = [...selectedCombinations, combinationId];
        }

        dispatch(changeBetSlipCombinations(newSelectedCombinations));
    };

    return activeTab === ticketTypeEnum.SYSTEM ? (
        <div className={'relative'} ref={ref}>
            <div
                className={styles.selectedCombination}
                disabled={commonValidations.length > 0 || systems.length === 0}
                onClick={onCombinationsMenuClick}
            >
                {getTranslation('betSlipCombinationsSelection')}{' '}
                <span className='icon-arrow-down' />
                <span className={styles.combinationsCount}>
                    {getTranslation('betSlipCombinationsSelectionSelected')} (
                    {selectedCombinations.length})
                </span>
            </div>
            {isComponentVisible && (
                <div className={styles.combinations}>
                    {systems.map(combination => {
                        const isSelected = selectedCombinations.includes(combination.id);
                        return (
                            <label
                                className={`${styles.label} ${isSelected ? styles.selected : ''}`}
                                key={combination.key}
                                onClick={() => onToggle(combination.id)}
                                htmlFor='combination'
                            >
                                <input type='checkbox' id='combination' checked={isSelected} />
                                <span className='m-l-1'>
                                    {combination.id}/{combination.of}
                                    {' - '}
                                    {combination.combinations}{' '}
                                    {getTranslation('betSlipCombinationsBets')}
                                </span>
                            </label>
                        );
                    })}
                </div>
            )}
        </div>
    ) : null;
};

export default SystemCombinations;
